export default __webpack_public_path__ + "static/media/G0860.Breech_05-AllFours-baby_out.1695378000000.dd1151a0.jpg";